import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ContractInboundMail } from "../_types/contract-inbound-mail";

@Injectable({
  providedIn: 'root',
})
export class ContractInboundMailsService extends Service<ContractInboundMail> {
  public override type = 'contractsInboundMails';
  public override url = 'attendance/contractsInboundMails';
}